import { INTEREST_PREVIEW } from "constants/actionTypes";

import { apiModelOfflineFetchReducer } from "lib/reducers";
import { deserializeInterestPreview } from "lib/serializers/interestPreview";

const fetchReducer = apiModelOfflineFetchReducer(INTEREST_PREVIEW, {
  deserializer: deserializeInterestPreview,
  clearOnRequest: true,
});

export default (state, action) => {
  const nextState = fetchReducer(state, action);

  switch (action.type) {
    case INTEREST_PREVIEW.CREATE.REQUEST:
      return { ...nextState, isCreating: true };
    case INTEREST_PREVIEW.CREATE.SUCCESS:
    case INTEREST_PREVIEW.CREATE.FAILURE:
      return { ...nextState, isCreating: false };
    default:
      return nextState;
  }
};
